var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"page-title"},[(_vm.editable)?_c('v-text-field',{attrs:{"loading":_vm.loading,"error":_vm.error,"value":_vm.content},on:{"change":function (val) { _vm.content = val; }}}):[_vm._v("\n    "+_vm._s(_vm.content)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55b8aef0","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageTitle.vue
// module id = null
// module chunks = 